// extracted by mini-css-extract-plugin
export var bullet = "_ma-q";
export var bulletText = "_ma-p";
export var bullets = "_ma-k";
export var callout = "_ma-g";
export var calloutBody = "_ma-i";
export var calloutLabel = "_ma-h";
export var checkIcon = "_ma-m";
export var checkList = "_ma-j";
export var checkSvg = "_ma-n";
export var checkText = "_ma-o";
export var fieldCard = "_ma-1";
export var fieldDescription = "_ma-5";
export var fieldHeader = "_ma-3";
export var fieldTitle = "_ma-4";
export var finalNote = "_ma-s";
export var flow = "_ma-x";
export var flowArrow = "_ma-v";
export var flowStep = "_ma-u";
export var helperText = "_ma-r";
export var inlineTitle = "_ma-t";
export var listItem = "_ma-l";
export var noteBody = "_ma-8";
export var noteBodyText = "_ma-9";
export var noteCard = "_ma-2";
export var noteIcon = "_ma-6";
export var noteTitle = "_ma-7";
export var productChoices = "_ma-w";
export var radioDot = "_ma-d";
export var radioDotSelected = "_ma-e";
export var radioDotSvg = "_ma-f";
export var selectableCard = "_ma-b";
export var selectableCardSelected = "_ma-c";
export var strongText = "_ma-a";
export var subHeading = "_ma-0";